<template>
  <div class="social-icons">
      <!-- ** Facebook ** -->
      <a class="social-icons__icon" :href="links.facebook" target="_blank" title="facebook">
        <span class="icon-facebook"></span>
      </a>

      <!-- ** Instagram ** -->
      <a class="social-icons__icon" :href="links.instagram" target="_blank" title="instagram">
        <span class="icon-instagram"></span>
      </a>

      <!-- ** Youtube ** -->
      <a class="social-icons__icon" :href="links.youtube" target="_blank" title="youtube">
        <span class="icon-youtube"></span>
      </a>
  </div>
</template>

<script>
export default {
    name: 'SocialIcons',
    data: () => ({
        links: {
            facebook: 'https://www.facebook.com/sitizzoequestre/',
            instagram: 'https://www.instagram.com/azienda_bio_agartur/',
            youtube: 'https://www.youtube.com/channel/UCIZmwrejLDJSng2Xqb9vpTQ',
        },
    }),
}
</script>

<style lang="scss">
    .social-icons{
        text-align: right;

        &__icon{
            font-size: 19.5px;
            margin-left: 20px;

            &:hover{
              color: $orange--neutral-2;
              cursor: pointer;
              transition: 0.25s color ease;
            }
        }
    }
</style>
